import colors from '../../colors';

const DayScreenTheme = {
  appColors: {
    background: colors.linearGradient,
    titleText: colors.gray.light,
    regularText: colors.white.primary,
    contentBackground: colors.conentGradient,
    secondaryGray: colors.white.primary,
    bottomBar: colors.bottomGradient,
    primaryWhite: colors.white.primary,
    bgSolidColor: colors.blue.violet,
    dayDateBackground: colors.blue.blueDark,
  },
};

export default DayScreenTheme;
